<div class="flex h-screen w-full bg-slate-50 relative">
  
  <div 
    *ngIf="!isCollapsed"
    (click)="closeSidebar()"
    class="fixed inset-0 z-20 bg-slate-900/50 backdrop-blur-sm transition-opacity lg:hidden">
  </div>

  <aside 
    class="fixed lg:static inset-y-0 left-0 z-30 flex flex-col border-r border-slate-200 bg-white transition-all duration-300 ease-in-out h-full shadow-lg lg:shadow-none"
    [class.w-64]="!isCollapsed"
    [class.w-20]="isCollapsed"
    [class.-translate-x-full]="isCollapsed && isMobile" 
    [class.translate-x-0]="!isCollapsed || !isMobile">
    
    <div class="flex h-16 items-center border-b border-slate-100 px-4">
      <div class="flex items-center gap-3 w-full">
        <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-r from-[#BF7A7A] to-[#6E7E97] shadow-md overflow-hidden">
           <img src="../../../../assets/cropped-logosmaller.png" alt="Logo" class="h-8 w-8 object-contain" />
        </div>
        
        <div *ngIf="!isCollapsed" class="flex flex-col animate-fade-in whitespace-nowrap overflow-hidden">
          <span class="text-sm font-bold text-slate-900 tracking-tight">GEORGI'S GARAGE</span>
          <span class="text-[10px] font-medium text-slate-500 uppercase tracking-wider">Admin Panel</span>
        </div>
      </div>
    </div>

    <nav class="flex-1 overflow-y-auto py-4 px-3 space-y-1">
      
      <a *ngIf="roleId === RoleNomenclature.ADMIN || roleId === RoleNomenclature.MANAGER"
         routerLink="/admin/approve-appointments"
         (click)="onLinkClick()"
         class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer"
         [ngClass]="getActiveClass('/admin/approve-appointments')">
        
        <lucide-icon name="check-circle" class="h-5 w-5 shrink-0 transition-colors"
          [class.text-white]="isActive('/admin/approve-appointments')"
          [class.text-slate-400]="!isActive('/admin/approve-appointments')">
        </lucide-icon>
        
        <span *ngIf="!isCollapsed" class="whitespace-nowrap">Заявки</span>
      </a>

      <a routerLink="/admin/appointments"
         (click)="onLinkClick()"
         class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer"
         [ngClass]="getActiveClass('/admin/appointments')">
        
        <lucide-icon name="calendar" class="h-5 w-5 shrink-0 transition-colors"
          [class.text-white]="isActive('/admin/appointments')"
          [class.text-slate-400]="!isActive('/admin/appointments')">
        </lucide-icon>
        
        <span *ngIf="!isCollapsed" class="whitespace-nowrap">График</span>
      </a>

      <a *ngIf="roleId === RoleNomenclature.ADMIN || roleId === RoleNomenclature.MANAGER"
         routerLink="/admin/services"
         (click)="onLinkClick()"
         class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer"
         [ngClass]="getActiveClass('/admin/services')">
        
        <lucide-icon name="settings" class="h-5 w-5 shrink-0 transition-colors"
          [class.text-white]="isActive('/admin/services')"
          [class.text-slate-400]="!isActive('/admin/services')">
        </lucide-icon>
        
        <span *ngIf="!isCollapsed" class="whitespace-nowrap">Услуги</span>
      </a>

      <a *ngIf="roleId === RoleNomenclature.ADMIN"
         routerLink="/admin/users"
         (click)="onLinkClick()"
         class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer"
         [ngClass]="getActiveClass('/admin/users')">
        
        <lucide-icon name="users" class="h-5 w-5 shrink-0 transition-colors"
          [class.text-white]="isActive('/admin/users')"
          [class.text-slate-400]="!isActive('/admin/users')">
        </lucide-icon>
        
        <span *ngIf="!isCollapsed" class="whitespace-nowrap">Служители</span>
      </a>

      <a *ngIf="roleId === RoleNomenclature.ADMIN || roleId === RoleNomenclature.MANAGER"
         routerLink="/admin/customers"
         (click)="onLinkClick()"
         class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer"
         [ngClass]="getActiveClass('/admin/customers')">
        
        <lucide-icon name="user" class="h-5 w-5 shrink-0 transition-colors"
          [class.text-white]="isActive('/admin/customers')"
          [class.text-slate-400]="!isActive('/admin/customers')">
        </lucide-icon>
        
        <span *ngIf="!isCollapsed" class="whitespace-nowrap">Клиенти</span>
      </a>

      <a *ngIf="roleId === RoleNomenclature.ADMIN"
         routerLink="/admin/vacations"
         (click)="onLinkClick()"
         class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer"
         [ngClass]="getActiveClass('/admin/vacations')">
        
        <lucide-icon name="palmtree" class="h-5 w-5 shrink-0 transition-colors"
          [class.text-white]="isActive('/admin/vacations')"
          [class.text-slate-400]="!isActive('/admin/vacations')">
        </lucide-icon>
        
        <span *ngIf="!isCollapsed" class="whitespace-nowrap">Почивки</span>
      </a>

    </nav>

    <div class="border-t border-slate-100 p-3 space-y-1">
      
      <button 
        (click)="logout()"
        class="group flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-slate-600 hover:bg-red-50 hover:text-red-600 transition-all duration-200 cursor-pointer">
        <lucide-icon name="log-out" class="h-5 w-5 shrink-0 text-slate-400 group-hover:text-red-500"></lucide-icon>
        <span *ngIf="!isCollapsed">Изход</span>
      </button>

      <button 
        (click)="toggleSidebar()"
        class="hidden lg:flex w-full items-center justify-center rounded-xl border border-slate-200 p-2 text-slate-400 transition-all duration-200 hover:bg-slate-50 hover:text-slate-600 cursor-pointer">
        <lucide-icon [name]="isCollapsed ? 'chevron-right' : 'chevron-left'" class="h-4 w-4"></lucide-icon>
      </button>
    </div>

  </aside>

  <main class="flex-1 h-full overflow-y-auto bg-slate-50 relative w-full lg:ml-0 transition-all duration-300">
    
    <button 
      (click)="openSidebar()" 
      class="lg:hidden absolute top-4 left-4 z-20 p-2 bg-white rounded-lg shadow-md text-slate-600">
      <lucide-icon name="menu" class="h-6 w-6"></lucide-icon>
    </button>

    <div class="p-6 md:p-8 max-w-7xl mx-auto mt-12 lg:mt-0">
      <router-outlet></router-outlet>
    </div>
  </main>

</div>